import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useSocketContext } from '../../context/SocketContext';
import ServerClock from './ServerClock';
import ThemeToggle from '../ThemeToggle';


// Pill nav items for the topbar
const NAV_PILLS = [
  { to: '/', label: 'Overview', icon: 'bi-speedometer2', end: true },
  { to: '/data', label: 'Data', icon: 'bi-database' },
  { to: '/schedule', label: 'Schedule', icon: 'bi-calendar-check' },
  { to: '/logs', label: 'Logs', icon: 'bi-terminal' },
];

const TopBar = () => {
  const { logout } = useAuth();
  const { isConnected } = useSocketContext();

  return (
    <header className="topbar" role="banner">
      {/* Left: pill nav */}
      <div className="topbar-left">
        <nav className="topbar-pill-nav" aria-label="Main navigation">
          {NAV_PILLS.map(({ to, label, icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `topbar-pill${isActive ? ' topbar-pill--active' : ''}`
              }
            >
              <i className={`bi ${icon}`} aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Right: connection + clock + theme + logout */}
      <div className="topbar-right">
        <div
          className={`connection-badge ${isConnected ? 'connected' : 'disconnected'}`}
          aria-label={isConnected ? 'Server connected' : 'Server disconnected'}
          title={isConnected ? 'Connected to server' : 'Disconnected from server'}
        >
          <span className="connection-dot" aria-hidden="true" />
          <span className="d-none d-sm-inline">
            {isConnected ? 'Live' : 'Offline'}
          </span>
        </div>

        <ServerClock />
        <ThemeToggle />

        <button
          className="topbar-icon-btn logout-btn"
          onClick={logout}
          aria-label="Log out"
          title="Log out"
        >
          <i className="bi bi-box-arrow-right" aria-hidden="true" />
        </button>
      </div>
    </header>
  );
};

export default TopBar;
